import type { TranslationComponentOptionsProp, TranslationKey } from "@/modules/i18n/components/types"
import type { I18nNamespace } from "@/modules/i18n/types"
import type { FunctionComponent, PropsWithChildren, ReactNode } from "react"

import { useLocale } from "@/modules/locales/useLocale"

import { useTranslation } from "./useTranslation"

export const Translation: FunctionComponent<
  PropsWithChildren<{
    i18nKey: TranslationKey
    isLazy?: boolean
  }> &
    TranslationComponentOptionsProp<ReactNode>
> = ({ children, i18nKey, isLazy = false, ...options }) => {
  const requestedNamespace = i18nKey.split(".")[0] as I18nNamespace
  const { ready, tReact } = useTranslation([requestedNamespace], isLazy)
  const locale = useLocale()

  if (isLazy && !ready) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>
  }

  return <>{tReact(i18nKey, { ...options, locale })}</>
}
